module.exports = __webpack_public_path__ + "img/48.22fca9d4.jpg";